import React from "react";
import { TChunkStatus } from "../types/db";

interface StuckChunk {
  chunkNo: number;
  status: TChunkStatus;
  size: number;
  createdAt: number;
}

interface StuckChunksData {
  videoGuid: string;
  uploadId?: string;
  key?: string;
  chunks: StuckChunk[];
}

interface DownloadProgress {
  current: number;
  total: number;
  currentVideoGuid: string;
}

interface StuckChunksOverlayProps {
  stuckChunks: StuckChunksData[];
  totalStuckChunks: number;
  isDownloadingAndDiscarding: boolean;
  downloadProgress: DownloadProgress | null;
  onDiscardStuckChunks: () => void;
  handleDownloadAndDiscard: () => void;
}

function DownloadOnlyOverlay({
  stuckChunks,
  totalStuckChunks,
  isDownloadingAndDiscarding,
  downloadProgress,
  onDiscardStuckChunks,
  handleDownloadAndDiscard,
}: StuckChunksOverlayProps) {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20,
        borderRadius: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
          color: "white",
          maxWidth: 500,
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: 48,
            color: "#1890ff",
          }}
        >
          💾
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 500,
          }}
        >
          {"Save Recording"}
        </div>
        {/* <div
          style={{
            fontSize: 14,
            opacity: 0.8,
            marginBottom: 8,
          }}
        >
          {`We found ${totalStuckChunks} chunk${
            totalStuckChunks !== 1 ? "s" : ""
          } from ${stuckChunks.length} recording${
            stuckChunks.length !== 1 ? "s" : ""
          } that were interrupted during recording.`}
        </div> */}
        <div
          style={{
            fontSize: 12,
            opacity: 0.7,
            marginBottom: 16,
          }}
        >
          Would you like to save your recording?
        </div>
        {isDownloadingAndDiscarding && downloadProgress && (
          <div
            style={{
              fontSize: 12,
              opacity: 0.8,
              marginBottom: 16,
              textAlign: "center",
              color: "#52c41a",
            }}
          >
            Downloading video {downloadProgress.current} of{" "}
            {downloadProgress.total}
            {downloadProgress.currentVideoGuid && (
              <div
                style={{
                  fontSize: 10,
                  opacity: 0.6,
                  marginTop: 4,
                }}
              >
                ID: {downloadProgress.currentVideoGuid.substring(0, 8)}
                ...
              </div>
            )}
          </div>
        )}
        <div
          style={{
            display: "flex",
            gap: 12,
          }}
        >
          <button
            onClick={handleDownloadAndDiscard}
            disabled={isDownloadingAndDiscarding}
            style={{
              backgroundColor: isDownloadingAndDiscarding
                ? "#d9d9d9"
                : "#52c41a",
              color: isDownloadingAndDiscarding ? "#8c8c8c" : "white",
              border: "none",
              borderRadius: 6,
              padding: "8px 16px",
              fontSize: 14,
              fontWeight: 500,
              cursor: isDownloadingAndDiscarding ? "not-allowed" : "pointer",
              transition: "background-color 0.2s",
              opacity: isDownloadingAndDiscarding ? 0.6 : 1,
            }}
            onMouseEnter={(e) => {
              if (!isDownloadingAndDiscarding) {
                e.currentTarget.style.backgroundColor = "#73d13d";
              }
            }}
            onMouseLeave={(e) => {
              if (!isDownloadingAndDiscarding) {
                e.currentTarget.style.backgroundColor = "#52c41a";
              }
            }}
          >
            {isDownloadingAndDiscarding
              ? downloadProgress
                ? `Saving ${downloadProgress.current}/${downloadProgress.total}...`
                : "Saving..."
              : "Save Recording"}
          </button>
          <button
            onClick={onDiscardStuckChunks}
            disabled={isDownloadingAndDiscarding}
            style={{
              backgroundColor: isDownloadingAndDiscarding
                ? "#d9d9d9"
                : "#ff4d4f",
              color: isDownloadingAndDiscarding ? "#8c8c8c" : "white",
              border: "none",
              borderRadius: 6,
              padding: "8px 16px",
              fontSize: 14,
              fontWeight: 500,
              cursor: isDownloadingAndDiscarding ? "not-allowed" : "pointer",
              transition: "background-color 0.2s",
              opacity: isDownloadingAndDiscarding ? 0.6 : 1,
            }}
            onMouseEnter={(e) => {
              if (!isDownloadingAndDiscarding) {
                e.currentTarget.style.backgroundColor = "#ff7875";
              }
            }}
            onMouseLeave={(e) => {
              if (!isDownloadingAndDiscarding) {
                e.currentTarget.style.backgroundColor = "#ff4d4f";
              }
            }}
          >
            {isDownloadingAndDiscarding ? "Processing..." : "Delete Recording"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DownloadOnlyOverlay;
export type { StuckChunksOverlayProps, StuckChunksData, DownloadProgress };
